import {getSupplierUnitDetailsDataSource} from '@store/suppliers/units/details/suppliers-units-details.requests';
import {suppliersUnitsDetailsStore} from '@store/suppliers/units/details/suppliers-units-details.store';

export class SuppliersUnitsDetailsQuery {
  store = suppliersUnitsDetailsStore;

  supplierUnitDetails$ = getSupplierUnitDetailsDataSource.data$();
}

export const suppliersUnitsDetailsQuery = new SuppliersUnitsDetailsQuery();
